/**
 * Given an image object and a set of requirements, raise an exception if the requirements are not met.
 * @param {object} image Image object passed back from the API including crop information.
 * @param {object} imageRequirements Object containing validation requirements for the image.
 */
const defaultImageValidator = (image, imageRequirements) => {
  const { minWidth, minHeight } = imageRequirements;
  const overMinWidth = minWidth ? image.orig_width >= minWidth : true;
  const overMinHeight = minHeight ? image.orig_height >= minHeight : true;

  if (!(overMinWidth && overMinHeight)) {
    if (minWidth && minHeight) {
      throw new Error(
        `Please upload an image that's at least ${minWidth} x ${minHeight}.`
      );
    } else if (minWidth) {
      throw new Error(
        `Please upload an image that's at least ${minWidth} pixels wide.`
      );
    } else if (minHeight) {
      throw new Error(
        `Please upload an image that's at least ${minHeight} pixels tall.`
      );
    }
  }
};

export default defaultImageValidator;
